import { referralActionTypes } from '../actions/types';

const initialState = {
  referredList: [],
  referralList: [],
  referral: {},
  status: null,
};

export function referral(state = initialState, action) {
  switch (action.type) {
    case referralActionTypes.RESET_STATE:
      return {
        ...initialState,
      };
    case referralActionTypes.FETCH_REQUEST:
      return {
        ...state,
        status: 'loading',
        error: null,
      };
    case referralActionTypes.FETCH_SUCCESS:
      return {
        ...state,
        status: 'success',
        referredList: action.referredList,
        referralList: action.referralList,
        error: null,
      };
    case referralActionTypes.FETCH_FAILURE:
      return {
        ...state,
        status: 'failed',
        error: action.error,
      };
    case referralActionTypes.FIND_REQUEST:
      return {
        ...state,
        status: 'loading',
        error: null,
      };
    case referralActionTypes.FIND_SUCCESS:
      return {
        ...state,
        status: 'success',
        referral: action.referral,
        error: null,
      };
    case referralActionTypes.FIND_FAILURE:
      return {
        ...state,
        status: 'failed',
        error: action.error,
      };
    case referralActionTypes.CREATE_REQUEST:
      return {
        ...state,
        status: 'loading',
        error: null,
      };
    case referralActionTypes.CREATE_SUCCESS:
      return {
        ...state,
        status: 'success',
        referralList: [...state.referralList, action.referral],
        error: null,
      };
    case referralActionTypes.CREATE_FAILURE:
      return {
        ...state,
        status: 'failed',
        error: action.error,
      };
    case referralActionTypes.UPDATE_REQUEST:
      return {
        ...state,
        status: 'loading',
        error: null,
      };
    case referralActionTypes.UPDATE_SUCCESS:
      const index = state.referralList.findIndex(element => element._id === action.referral._id);
      const updatedList = state.referralList;
      updatedList[index] = { ...action.referral }
      return {
        ...state,
        status: 'success',
        referralList: updatedList,
        error: null,
      };
    case referralActionTypes.UPDATE_FAILURE:
      return {
        ...state,
        status: 'failed',
        error: action.error,
      };
    case referralActionTypes.ADD_CODE_REQUEST:
      return {
        ...state,
        status: 'loading',
        error: null,
      };
    case referralActionTypes.ADD_CODE_SUCCESS:
      const referral = state.referral;
      referral.codes = action.codes
      return {
        ...state,
        status: 'success',
        referral: referral,
        error: null,
      };
    case referralActionTypes.ADD_CODE_FAILURE:
      return {
        ...state,
        status: 'failed',
        error: action.error,
      };
    case referralActionTypes.UPDATE_CODE_REQUEST:
      return {
        ...state,
        status: 'loading',
        error: null,
      };
    case referralActionTypes.UPDATE_CODE_SUCCESS:
      const updateReferral = state.referral;
      updateReferral.codes = action.codes
      return {
        ...state,
        status: 'success',
        referral: updateReferral,
        error: null,
      };
    case referralActionTypes.UPDATE_CODE_FAILURE:
      return {
        ...state,
        status: 'failed',
        error: action.error,
      };
    default:
      return state;
  }
}
